import useSelectBase from './Select.hook'
import {
  BaseSelect,
  Chevron,
  ErrorText,
  Label,
  Root,
  SelectWrapper,
} from './Select.styles'

export const useSelect = useSelectBase

const getOptionValue = option => option?.value ?? option?.id ?? ''
const getOptionLabel = option => option?.label ?? option?.name ?? String(getOptionValue(option))

const Select = ({
  name,
  value,
  options = [],
  onChange,
  disabled = false,
  label,
  error,
  placeholder,
  id,
}) => {
  const hasError = Boolean(error)
  const selectId = id || name

  return (
    <Root>
      {label && <Label htmlFor={selectId}>{label}</Label>}
      <SelectWrapper>
        <BaseSelect
          id={selectId}
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
          $hasError={hasError}
          aria-invalid={hasError || undefined}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map(opt => {
            const optionValue = getOptionValue(opt)
            return (
              <option key={optionValue} value={optionValue}>
                {getOptionLabel(opt)}
              </option>
            )
          })}
        </BaseSelect>
        <Chevron aria-hidden />
      </SelectWrapper>
      {hasError && <ErrorText>{error}</ErrorText>}
    </Root>
  )
}

export default Select
